<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-on="on" icon color="error">
        <v-icon>mdi-account-key-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title v-if="User">{{
          User.FullName + " { " + User.UserName + " }"
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon text :disabled="clicked" @click="close" dark color=""
          ><v-icon>mdi-close-thick</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <!-- <p>{{ User }}</p> -->
          <v-col cols="8">
            <p v-if="ErrMessage" v-html="ErrMessage" class="red--text"></p>
          </v-col>
          <v-col cols="8">
            <v-form ref="ChangePassForm">
              <v-text-field
                validate-on-blur
                v-model="Passwords.NewPass"
                :rules="[requiredFild, lengthPass]"
                name="NewPass"
                label="New Password"
                id="newPassid"
              ></v-text-field>
              <v-text-field
                validate-on-blur
                v-model="Passwords.ConfirmPass"
                :rules="[requiredFild, MutchPassword]"
                name="ConfPass"
                label="Confirm Password"
                id="ConfPassid"
              ></v-text-field>
              <v-btn
                :loading="clicked"
                block
                @click="OnchangePass"
                color="success"
                >Change Password</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    User: { type: Object },
  },
  data() {
    return {
      // colorName:"",
      ErrMessage: "",
      clicked: false,
      dialog: false,
      Passwords: { NewPass: "", ConfirmPass: "" },
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$refs.ChangePassForm.reset();
      }
    },
  },
  methods: {
    OnchangePass() {
      this.ErrMessage = "";
      if (this.$refs.ChangePassForm.validate()) {
        this.clicked = true;
        this.Passwords.UserName = this.User.UserName;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/users/ForceChangepass",
            data: {
              Passwords: this.Passwords,
            },
          })
          .then(() => {
            this.clicked = false;
            // console.log(value);
            this.close();
          })
          .catch(error => {
            this.clicked = false;
            // console.log(error);
            if (error.response) this.ErrMessage = error.response.data;
          });
      }
    },
    close() {
      this.dialog = false;
      this.msgError = "";
    },
    requiredFild(v) {
      if (!v) return "this is required";
      else return true;
    },
    MutchPassword() {
      if (this.Passwords.NewPass != this.Passwords.ConfirmPass)
        return "passwords in not match";
      else return true;
    },
    lengthPass(v) {
      if (v && v.length < 6) return "Min length is 6";
      return true;
    },
  },
};
</script>
